export default {
    menu: "Menu",
    close_menu: "Close Menu",
    viewing_as: "Viewing as:",

    // Menu items
    pdv: "POS",
    tasks: "Tasks",
    tasks_list: "List",
    tasks_boards: "Boards",

    metrics: "Metrics",
    rfm_analysis: "RFM Analysis",
    sales: "Sales",
    retention_cohort: "Retention and Cohort",
    clients: "Clients",
    messages: "Messages",
    quotations: "Quotations",

    forms: "Forms",
    forms_manage: "Manage Forms",
    forms_answers: "Answers",

    contacts: "Contacts",
    contact_base: "Contact Base",
    coupons_list: "Coupons List",
    segments: "Segments",
    inbox: "Answers",

    marketing_actions: "Marketing Actions",

    benefits_center: "Benefits Center",
    settings: "Settings",
    users: "Users",
    data_sets: "Data Sets",
    connections: "Connections",
    whatsapp_connections: "WhatsApp Connections",
    credits: "Credits",
    custom_events: "Custom Events",
    client_fields: "Client fields",
    order_fields: "Order fields",
    quotation_fields: "Quotation fields",
    order_status: "Order status",
    quotation_status: "Quotation status",
    notification_schedule: "Notification Sending Schedule",
    utm_auto: "Automatic UTM",
    agent_authorizations: "Agent authorizations",
    products: "Products",
    files_gallery: "Files Gallery",
    client_base_management: "Client base management",
    import_history: "Import data",

    establishments: "Establishments",
    list: "List",
    plans: "Plans",
    adoption_report: "Adoption Report",
    translations: "Translations",
    email: "Email",
    email_generator: "Email Generator",

    my_account: "My Account",
    hello: "Hello, {0}!",
    reset_password: "Reset Password",
    my_profile: "My profile",
    two_factor_auth: "2FA Authentication",
    logout: "Logout",

    support: "Support",
    navigate: "Navigate",
    close: "Close",
    logo_alt: "Kevi Logo",

    // Logout confirmation
    logout_title: "Logout",
    logout_message: "Do you want to continue and logout from the system?",
    no: "No",
    yes: "Yes",
};
